import { mapState } from 'vuex';


export default {
  computed: {
    ...mapState('app', ['maintenance']),
  },
};



// WEBPACK FOOTER //
// ./src/components/maintenance-notification/maintenance-notification.js